export default __webpack_public_path__ + "static/media/select.946a846a.png";